var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"completo"},[_c('v-img',{staticClass:"selector",attrs:{"src":_vm.myProps.customizables.value == 1?require('./right.png'):require('./left.png')},on:{"click":function($event){_vm.getIsPlayMode?_vm.cambioManualDeValor():null}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }